// mocks
import MTT from "@images/mocks/Martini Triangle Top.webp"
import FH from "@images/mocks/collection-2.webp"
import CST from "@images/mocks/collection-3.webp"
import RCP from "@images/mocks/Regina Cargo Pants.webp"
import VRJ from "@images/mocks/Vanilla Rum Jacquard.webp"

import collection1 from "@images/mocks/collection-1.webp"
import collection2 from "@images/mocks/collection-2.webp"
import collection3 from "@images/mocks/collection-3.webp"
import collection4 from "@images/mocks/collection-4.webp"

import search_featured_1 from "@images/Search/club-voyages.webp"
import search_featured_2 from "@images/Search/sunsoaked.webp"


import lookbook1 from "@images/mocks/lookbook/lb1.webp"
import lookbook2 from "@images/mocks/lookbook/lb2.webp"
import lookbook3 from "@images/mocks/lookbook/lb3.webp"
import lookbook4 from "@images/mocks/lookbook/lb4.webp"

import print1 from "@images/ColorFilters/red_small.png"
import print2 from "@images/ColorFilters/orange_small.png"
import print3 from "@images/ColorFilters/yellow_small.png"
import print4 from "@images/ColorFilters/green_small.png"
import print5 from "@images/ColorFilters/blue_small.png"
import print6 from "@images/ColorFilters/purple_small.png"
import print7 from "@images/ColorFilters/pink_small.png"
import print8 from "@images/ColorFilters/white_small.png"
import print9 from "@images/ColorFilters/black_small.png"
import print10 from "@images/ColorFilters/beige_small.png"
import print11 from "@images/ColorFilters/brown_small.png"
import print12 from "@images/ColorFilters/multi-color_small.png"


import emptyThumb1 from '@images/mocks/empty-bag-thumb-1.webp'
import emptyThumb2 from '@images/mocks/empty-bag-thumb-2.webp'
import emptyThumb3 from '@images/mocks/empty-bag-thumb-3.webp'
import emptyThumb4 from '@images/mocks/empty-bag-thumb-4.webp'

import cheeky from "@images/Products/cheeky.svg"
import midRise from "@images/Products/mid-rise.svg"
import runsTrue from "@images/Products/runs-true.svg"

import lb01 from "@images/mocks/lookbook/lb-01.webp"
import lb02 from "@images/mocks/lookbook/lb-02.webp"
import lb03 from "@images/mocks/lookbook/lb-03.webp"
import lb04 from "@images/mocks/lookbook/lb-04.webp"
import lb05 from "@images/mocks/lookbook/lb-05.webp"
import lb06 from "@images/mocks/lookbook/lb-06.webp"
import lb07 from "@images/mocks/lookbook/lb-07.webp"
import lb08 from "@images/mocks/lookbook/lb-08.webp"
import lb09 from "@images/mocks/lookbook/lb-09.webp"
import lb10 from "@images/mocks/lookbook/lb-10.webp"
import lb11 from "@images/mocks/lookbook/lb-11.webp"
import lb12 from "@images/mocks/lookbook/lb-12.webp"
import lb13 from "@images/mocks/lookbook/lb-13.webp"
import lb14 from "@images/mocks/lookbook/lb-14.webp"
import lbm1 from "@images/mocks/lookbook/lbmodal01.webp"
import lbm2 from "@images/mocks/lookbook/lbmodal02.webp"
import lbm3 from "@images/mocks/lookbook/lbmodal03.webp"

import colCardImg from "@images/mocks/collection-card-image.webp"

import blogPost1 from "@images/mocks/blogpost/blog-thumb-1.webp"
import blogPost2 from "@images/mocks/blogpost/blog-thumb-2.webp"
import blogPost3 from "@images/mocks/blogpost/blog-thumb-3.webp"
import blogPost4 from "@images/mocks/blogpost/blog-thumb-4.webp"

// order history
import mockImage from '@images/mocks/mock-back-view.webp'

// rewards
import mockReward1 from '@images/mocks/rewards/mock-reward-1.webp'
import mockReward2 from '@images/mocks/rewards/mock-reward-2.webp'
import mockReward3 from '@images/mocks/rewards/mock-reward-3.webp'
import mockReward4 from '@images/mocks/rewards/mock-reward-4.webp'
import mockReward5 from '@images/mocks/rewards/mock-reward-5.webp'

// collection-listing
import colListing1 from '@images/mocks/collection-listing/apres-season.webp'
import colListing2 from '@images/mocks/collection-listing/golden-hour.webp'
import colListing3 from '@images/mocks/collection-listing/summer-vacays.webp'

export const MockProducts = [
  {
    id: 0,
    image: MTT,
    name: "Martini Triangle Top",
    sub: "Vanilla Rum Jacquard",
    tags: ['NEW ARRIVAL','BEST SELLER'],
    finalPrice: "90",
    price: "120",
    hug: true,
    isDiscounted: true,
    isNew: true,
    finalSale: true,
	size: "S"
  },
  {
    id: 1,
    image: FH,
    name: "Althea Bucket Hat",
    sub: "Rose",
    tags: ['NEW ARRIVAL','BEST SELLER'],
    finalPrice: "90",
    price: "120",
    hug: true,
    isDiscounted: true,
    isNew: true,
    finalSale: true,
	size: "M"
  },
  {
    id: 2,
    image: CST,
    name: "Chloe Side Tie Cheeky Bottoms",
    sub: "Sour Slush",
    tags: ['NEW ARRIVAL','BEST SELLER'],
    finalPrice: "90",
    price: "120",
    hug: true,
    isDiscounted: true,
    isNew: true,
    finalSale: true,
	size: "L"
  },
  {
    id: 3,
    image: RCP,
    name: "Regina Cargo Pants",
    sub: "Basil Smash",
    tags: ['NEW ARRIVAL','BEST SELLER'],
    finalPrice: "90",
    price: "120",
    hug: true,
    isDiscounted: true,
    isNew: true,
    finalSale: true,
	size: "XL"
  },
  {
    id: 4,
    image: VRJ,
    name: "Vanilla Rum Jacquard",
    sub: "Basil Smash",
    tags: ['NEW ARRIVAL','BEST SELLER'],
    finalPrice: "90",
    price: "120",
    hug: true,
    isDiscounted: true,
    isNew: true,
    finalSale: true,
	size: "+"
  },
  {
    id: 5,
    image: MTT,
    name: "Martini Triangle Top",
    sub: "Vanilla Rum Jacquard",
    tags: ['NEW ARRIVAL','BEST SELLER'],
    finalPrice: "90",
    price: "120",
    hug: true,
    isDiscounted: true,
    isNew: true,
    finalSale: true,
	size: "S"
  },
  {
    id: 6,
    image: FH,
    name: "Floppy Hat",
    sub: "Vanilla Rum Jacquard",
    tags: ['NEW ARRIVAL','BEST SELLER'],
    finalPrice: "90",
    price: "120",
    hug: true,
    isDiscounted: true,
    isNew: true,
    finalSale: true,
	size: "M"
  },
  {
    id: 7,
    image: CST,
    name: "Vanilla Rum Jacquard",
    tags: ['NEW ARRIVAL','BEST SELLER'],
    sub: "Basil Smash",
    finalPrice: "90",
    price: "120",
    hug: true,
    isDiscounted: true,
    isNew: true,
    finalSale: true,
	size: "L"
  },
]

export const MockCollections = [
  {
    id: 0,
    image: collection1,
    name: "Martini Triangle Top",
    sub: "Vanilla Rum Jacquard",
    buttonLabel: "CASA DEL MAR",
    finalPrice: "90",
    price: "120",
    hug: true,
    isDiscounted: true,
    isNew: true,
    finalSale: true,
  },
  {
    id: 1,
    image: collection2,
    name: "Martini Triangle Top",
    sub: "Vanilla Rum Jacquard",
    buttonLabel: "ROMANCE BOULEVARD",
    finalPrice: "90",
    price: "120",
    hug: true,
    isDiscounted: true,
    isNew: true,
    finalSale: true,
  },
  {
    id: 2,
    image: collection3,
    name: "Martini Triangle Top",
    sub: "Vanilla Rum Jacquard",
    buttonLabel: "SPELLBOUND",
    finalPrice: "90",
    price: "120",
    hug: true,
    isDiscounted: true,
    isNew: true,
    finalSale: true,
  },
  {
    id: 3,
    image: collection4,
    name: "Martini Triangle Top",
    sub: "Vanilla Rum Jacquard",
    buttonLabel: "SUNSET BEACH",
    finalPrice: "90",
    price: "120",
    hug: true,
    isDiscounted: true,
    isNew: true,
    finalSale: true,
  },
  {
    id: 4,
    image: search_featured_1,
    name: "CLUB VOYAGES",
    sub: "CLUB VOYAGES",
    buttonLabel: "CLUB VOYAGES",
    finalPrice: "90",
    price: "120",
    hug: true,
    isDiscounted: true,
    isNew: true,
    finalSale: true,
    to: "/collections/the-club-voyages-collection/"
  },
  {
    id: 5,
    image: search_featured_2,
    name: "SUNSOAKED",
    sub: "SUNSOAKED",
    buttonLabel: "SUNSOAKED",
    finalPrice: "90",
    price: "120",
    hug: true,
    isDiscounted: true,
    isNew: true,
    finalSale: true,
    to: "/collections/the-sunsoaked-collection/"
  },
]

export const MockLookbooks = [
  {
    id: 0,
    image: lookbook1,
    name: "Martini Triangle Top",
    sub: "Vanilla Rum Jacquard",
    buttonLabel: "Shop the look",
    finalPrice: "90",
    price: "120",
    hug: true,
    isDiscounted: true,
    isNew: true,
    finalSale: true,
	title: 'lb1',
  },
  {
    id: 1,
    image: lookbook2,
    name: "Martini Triangle Top",
    sub: "Vanilla Rum Jacquard",
    buttonLabel: "Shop the look",
    finalPrice: "90",
    price: "120",
    hug: true,
    isDiscounted: true,
    isNew: true,
    finalSale: true,
	title: 'lb2',
  },
  {
    id: 2,
    image: lookbook3,
    name: "Martini Triangle Top",
    sub: "Vanilla Rum Jacquard",
    buttonLabel: "Shop the look",
    finalPrice: "90",
    price: "120",
    hug: true,
    isDiscounted: true,
    isNew: true,
    finalSale: true,
	title: 'lb3',
  },
  {
    id: 3,
    image: lookbook4,
    name: "Martini Triangle Top",
    sub: "Vanilla Rum Jacquard",
    buttonLabel: "Shop the look",
    finalPrice: "90",
    price: "120",
    hug: true,
    isDiscounted: true,
    isNew: true,
    finalSale: true,
	title: 'lb4',
  },
  {
    id: 4,
    image: lookbook1,
    name: "Martini Triangle Top",
    sub: "Vanilla Rum Jacquard",
    buttonLabel: "Shop the look",
    finalPrice: "90",
    price: "120",
    hug: true,
    isDiscounted: true,
    isNew: true,
    finalSale: true,
	title: 'lb5',
  },
  {
    id: 5,
    image: lookbook2,
    name: "Martini Triangle Top",
    sub: "Vanilla Rum Jacquard",
    buttonLabel: "Shop the look",
    finalPrice: "90",
    price: "120",
    hug: true,
    isDiscounted: true,
    isNew: true,
    finalSale: true,
	title: 'lb6',
  },
  {
    id: 6,
    image: lookbook3,
    name: "Martini Triangle Top",
    sub: "Vanilla Rum Jacquard",
    buttonLabel: "Shop the look",
    finalPrice: "90",
    price: "120",
    hug: true,
    isDiscounted: true,
    isNew: true,
    finalSale: true,
	title: 'lb7',
  },
]

export const MockPrintedPalettes = [
  { id: 'print-01', name: 'Red', image: print1, value: 'filter_red' },
  { id: 'print-02', name: 'Orange', image: print2, value: 'filter_orange' },
  { id: 'print-03', name: 'Yellow', image: print3, value: 'filter_yellow' },
  { id: 'print-04', name: 'Green', image: print4, value: 'filter_green' },
  { id: 'print-05', name: 'Blue', image: print5, value: 'filter_blue' },
  { id: 'print-06', name: 'Purple', image: print6, value: 'filter_purple' },
  { id: 'print-07', name: 'Pink', image: print7, value: 'filter_pink' },
  { id: 'print-08', name: 'White', image: print8, value: 'filter_white' },
  { id: 'print-09', name: 'Black', image: print9, value: 'filter_black' },
  { id: 'print-10', name: 'Beige', image: print10, value: 'filter_beige' },
  { id: 'print-11', name: 'Brown', image: print11, value: 'filter_brown' },
  { id: 'print-12', name: 'Multi Color', image: print12, value: 'filter_multi-color' },
]


export const MockIconDetails = [
  {label: 'Cheeky Adjustable Coverage', image: cheeky},
  {label: 'Mid-Rise', image: midRise},
  {label: 'Runs True to Size', image: runsTrue},
]

export const mockReviews = [
  {
    title: 'Supportive tops!',
    rating: 5,
    product: 'Lapiz Lazuli',
    review: 'First of all this print wow im so obsessed I got it in other styles! Also the Alana top is perfect for girls who need that extra support!',
    user: 'Caroline',
    date: 'Sep. 23, 2023',
  },
  {
    title: 'Please make a silk blend variant!',
    rating: 4,
    product: 'Lapiz Lazuli',
    review: 'Lightweight and heat-regulating. No snags or pilling so far after a few washes.',
    user: 'Caroline',
    date: 'Sep. 23, 2023',
  },
  {
    title: 'Beautiful!!',
    rating: 5,
    product: 'Lapiz Lazuli',
    review: 'First of all this print wow im so obsessed I got it in other styles! Also the Alana top is perfect for girls who need that extra support!',
    user: 'Caroline',
    date: 'Sep. 23, 2023',
  },
  {
    title: 'Could be better',
    rating: 3,
    product: 'Lapiz Lazuli',
    review: 'First of all this print wow im so obsessed I got it in other styles! Also the Alana top is perfect for girls who need that extra support!',
    user: 'Caroline',
    date: 'Sep. 23, 2023',
  },
  
]

export const mockEmptyBag = [
  {
    image: emptyThumb1,
    label: 'New Arrivals',
  },
  {
    image: emptyThumb2,
    label: 'Best Sellers',
  },
  {
    image: emptyThumb3,
    label: 'Selling Fast',
  },
  {
    image: emptyThumb4,
    label: 'Popular Collections',
  },
]

export const mockAnnouncements = [
  {id: 0, text: `<a href="https://blackboughswim.ph/collections/the-city-sweetheart-collection/">💌 NEW IN: Meet the Maddy Set in Uptown Girl, your new limited-edition must-have. Shop now →</a>`},
  {id: 1, text: `<a href="https://blackboughswim.com/en-ph/pages/student-discount">STUDY HARD, SLAY HARDER! Get 30% off with your Student Discount. Sign up here!</a>`},
  // {id: 0, text: `Free Shipping for $100 up`},
  // {id: 1, text: `The Holiday Gift Shop is Now Open! &#127876;&#10024; Find the Perfect Gifts Here →`}
]

export const mockBento = [
  {
    id: 1,
    image: lb01,
    videoUrl: '',
  },
  {
    id: 2,
    image: lb02,
    videoUrl: '',
  },
  {
    id: 3,
    image: lb03,
    videoUrl: '',
  },
  {
    id: 4,
    image: lb04,
    videoUrl: '',
  },
  {
    id: 5,
    image: lb05,
    videoUrl: '',
  },
  {
    id: 6,
    image: lb06,
    videoUrl: '',
  },
  {
    id: 7,
    image: lb07,
    videoUrl: '',
  },
  {
    id: 8,
    image: lb08,
    videoUrl: '',
  },
  {
    id: 9,
    image: lb09,
    videoUrl: '',
  },
  {
    id: 10,
    image: lb10,
    videoUrl: '',
  },
  {
    id: 11,
    image: lb11,
    videoUrl: '',
  },
  {
    id: 12,
    image: lb12,
    videoUrl: '',
  },
  {
    id: 13,
    image: lb13,
    videoUrl: '',
  },
  {
    id: 14,
    image: lb14,
    videoUrl: '',
  },
]

export const lbModalKit = [
  {
    id: 0,
    image: lbm1,
    name: "Candice Ruffled Cheeky Top",
    sub: "Dusk Eyelet",
    price: "$55",
  },
  {
    id: 1,
    image: lbm2,
    name: "Candice Ruffled Cheeky Bottom",
    sub: "Dusk Eyelet",
    price: "$55",
  },
  {
    id: 2,
    image: lbm3,
    name: "Alana Tie front Top",
    sub: "Dusk Eyelet",
    price: "$55",
  },
  {
    id: 3,
    image: lbm3,
    name: "Alana Tie front Bottom",
    sub: "Dusk Eyelet",
    price: "$55",
  },
  {
    id: 4,
    image: lbm1,
    name: "Candice Ruffled Cheeky Top",
    sub: "Dusk Eyelet",
    price: "$55",
  },
  {
    id: 5,
    image: lbm2,
    name: "Candice Ruffled Cheeky Bottom",
    sub: "Dusk Eyelet",
    price: "$55",
  },
  {
    id: 6,
    image: lbm3,
    name: "Alana Tie front Top",
    sub: "Dusk Eyelet",
    price: "$55",
  },
  {
    id: 7,
    image: lbm3,
    name: "Alana Tie front Bottom",
    sub: "Dusk Eyelet",
    price: "$55",
  },
]

export const collectionCards = [
  {
    id: 0,
    image: colCardImg,
    name: "The Avocado Collection",
  },
  {
    id: 1,
    image: colCardImg,
    name: "The Daisy Blooms Collection",
  },
  {
    id: 2,
    image: colCardImg,
    name: "The Tutti Frutti Collection",
  },
  {
    id: 3,
    image: colCardImg,
    name: "The Pool House Collection",
  },
  {
    id: 4,
    image: colCardImg,
    name: "The Weaves Collection",
  },
  {
    id: 5,
    image: colCardImg,
    name: "The Floral Punch Collection",
  },
  {
    id: 6,
    image: colCardImg,
    name: "Berry Cherry: The Remix Collection",
  },
  {
    id: 7,
    image: colCardImg,
    name: "The Pink Twinkle Collection",
  },
  {
    id: 8,
    image: colCardImg,
    name: "The Zooted Collection",
  },
  {
    id: 9,
    image: colCardImg,
    name: "The Spring Fling Collection",
  },
  {
    id: 10,
    image: colCardImg,
    name: "The Iced Coconut Collection",
  },
  {
    id: 11,
    image: colCardImg,
    name: "The Paradise Found Collection ",
  },
]

export const mockMoreBlogs = [
  {
    id: 0,
    thumb: blogPost1,
    title: "Plastic Waste Upcycling with Retaso",
    date: "October 25, 2024",
    tags: ["Events", "Lifestyle", "Stories"],
    url: "/blogs/blogpost",
    content: "Blackbough Swim is thrilled to share that we are an official Plastic Waste Upcycling Donor to Retaso, a social and environmental enterprise based in the Philippines. As we aspire to become more holistically sustainable in our business practices, we are constantly looking for new avenues to minimize waste and maximize impact. Learn more about Retaso and our pledge here."
  },
  {
    id: 1,
    thumb: blogPost2,
    title: "Cleaner Coasts 2024",
    date: "October 26, 2024",
    tags: ["Events",],
    url: "/blogs/blogpost",
    content: "This September, as we celebrate International Coastal Cleanup Day, Blackbough Swim invites you to make every wave count. In collaboration with Project CURMA, Blackbough is kicking off a two-part coastal cleanup initiative designed to protect the Philippine shorelines and aid in the rehabilitation of sea turtles."
  },
  {
    id: 2,
    thumb: blogPost3,
    title: "Where to buy the perfect swimwear from our Perfect Match",
    date: "October 27, 2024",
    tags: ["Lifestyle", "Stories"],
    url: "/blogs/blogpost",
    content: `Shot in the vibrant beaches of Tulum, “The Perfect Match" season 2 is perfect for showcasing stylish and tropical-friendly fashion. To help them meet their perfectly ever after, contestants on this Netflix dating show have dolled themselves up with the hottest pieces from Blackbough Swim.`
  },
  {
    id: 3,
    thumb: blogPost4,
    title: "Pink with Purpose",
    date: "October 28, 2024",
    tags: ["Events", "Stories"],
    url: "/blogs/blogpost",
    content: `As a brand founded by a woman and composed of incredible women, breast cancer awareness holds a special place in our hearts. The statistics reveal a sobering reality: 1 in 8 women in the United States will face the challenge of breast cancer in their lifetime. This figure reinforces the importance of raising awareness and standing shoulder to shoulder in support of those impacted. We are committed to using our platform for the betterment of women's lives.As a brand founded by a woman and composed of incredible women, breast cancer awareness holds a special place in our hearts. The statistics reveal a sobering reality: 1 in 8 women in the United States will face the challenge of breast cancer in their lifetime. This figure reinforces the importance of raising awareness and standing shoulder to shoulder in support of those impacted. We are committed to using our platform for the betterment of women's lives.`
},
]

export const mockSizeVariants = [
  { title: 'S', inventoryQuantity: 0 },
  { title: 'M', inventoryQuantity: 0 },
  { title: 'L', inventoryQuantity: 0 },
]

export const mockUserAccount = {
  id: '012345678',
  name: 'Marie Devin',
  firstName: 'Marie',
  lastName: 'Devin',
  emailAddress: 'marie.devin@example.com',
  countryCode: 'US',
  mobileNumber: '555-0173',
}

export const mockPaymentMethods = [
  { id: 1, owner: "Marie Devin", type: "Visa", name: 'Visa', expirationDate: '08/29', cardNumber: "4111222233331234", last4: "1234", cvv: "079", isDefault: true },
  { id: 2, owner: "Marie Devin", type: "MasterCard", name: 'MasterCard', expirationDate: '06/27', cardNumber: "555544433335678", last4: "5678", cvv: "012", isDefault: false },
  { id: 3, owner: "Marie Devin", type: "Amex", name: 'American Express', expirationDate: '10/30', cardNumber: "3745789045459101", last4: "9101", cvv: "048", isDefault: false },
];

export const mockOrderHistory = [
  {
    category: "All",
    orders: [
      {
        orderId: "467GHJKL1124",
        orderDate: "12/02/2024",
        productsOrdered: [
          {
            productId: '0',
            productImage: mockImage,
            productName: 'Floppy Hat / Banana Bunch (Free Size)',
            variant: "Banana Bunch",
            size: "+",
            price: "$55",
            sku: "000012",
            quantity: 1,
          },
          {
            productId: '1',
            productImage: FH,
            productName: 'Martini Triangle Top / Vanilla Rum Jacquard (Medium)',
            variant: "Vanilla Rum Jacquard",
            size: "M",
            price: "$55",
            sku: "000013",
            quantity: 1,
          },
          {
            productId: '2',
            productImage: VRJ,
            productName: 'Chloe Side Tie Cheeky Bottoms / NY Noir (Medium)',
            variant: "NY Noir",
            size: "M",
            price: "$55",
            sku: "000013",
            quantity: 1,
          },
          {
            productId: '3',
            productImage: CST,
            productName: 'Regina Cargo Pants / Basil Smash (Medium)',
            variant: "Basil Smash",
            size: "M",
            price: "$55",
            sku: "000013",
            quantity: 1,
          },
        ],
        totalPrice: "$220",
        status: "OUT FOR DELIVERY",
        trackingNumber: "SEBG1307156373607108608",
      },
      {
        orderId: "1233BB45667",
        orderDate: "12/12/2024",
        productsOrdered: [
          {
            productId: '0',
            productImage: VRJ,
            productName: 'Packable Beach Towel / Perla (Free Size)',
            variant: "Perla",
            size: "+",
            price: "$55",
            sku: "000012",
            quantity: 1,
          },
        ],
        totalPrice: "$55",
        status: "DELIVERED",
        trackingNumber: "SEBG1307156373607108608",
      },
      {
        orderId: "1413AE45223",
        orderDate: "12/12/2024",
        productsOrdered: [
          {
            productId: '0',
            productImage: FH,
            productName: 'Martini Triangle Top / Vanilla Rum Jacquard (Medium)',
            variant: "Vanilla Rum Jacquard",
            size: "M",
            price: "$60",
            sku: "000013",
            quantity: 1,
          },
        ],
        totalPrice: "$60",
        status: "UNFULFILLED",
        trackingNumber: "SEBG1307156373607108608",
      }
    ]
  },
  {
    category: "Order Placed",
    orders: []
  },
  {
    category: "Unfulfilled",
    orders: [{
      orderId: "1413AE45223",
      orderDate: "12/12/2024",
      productsOrdered: [
        {
          productId: '0',
          productImage: FH,
          productName: 'Martini Triangle Top / Vanilla Rum Jacquard (Medium)',
          variant: "Vanilla Rum Jacquard",
          size: "M",
          price: "$60",
          sku: "000013",
          quantity: 1,
        },
      ],
      totalPrice: "$60",
      status: "UNFULFILLED",
      trackingNumber: "SEBG1307156373607108608",
    }]
  },
  {
    category: "Fulfilled",
    orders: []
  },
  {
    category: "In Transit",
    orders: []
  },
  {
    category: "Out for Delivery",
    orders: [{
      orderId: "467GHJKL1124",
      orderDate: "12/02/2024",
      productsOrdered: [
        {
          productId: '0',
          productImage: mockImage,
          productName: 'Floppy Hat / Banana Bunch (Free Size)',
          variant: "Banana Bunch",
          size: "+",
          price: "$55",
          sku: "000012",
          quantity: 1,
        },
        {
          productId: '1',
          productImage: FH,
          productName: 'Martini Triangle Top / Vanilla Rum Jacquard (Medium)',
          variant: "Vanilla Rum Jacquard",
          size: "M",
          price: "$55",
          sku: "000013",
          quantity: 1,
        },
        {
          productId: '2',
          productImage: VRJ,
          productName: 'Chloe Side Tie Cheeky Bottoms / NY Noir (Medium)',
          variant: "NY Noir",
          size: "M",
          price: "$55",
          sku: "000013",
          quantity: 1,
        },
        {
          productId: '3',
          productImage: CST,
          productName: 'Regina Cargo Pants / Basil Smash (Medium)',
          variant: "Basil Smash",
          size: "M",
          price: "$55",
          sku: "000013",
          quantity: 1,
        },
      ],
      totalPrice: "$220",
      status: "OUT FOR DELIVERY",
      trackingNumber: "SEBG1307156373607108608",
    }]
  },
  {
    category: "Delivered",
    orders: [{
      orderId: "1233BB45667",
      orderDate: "12/12/2024",
      productsOrdered: [
        {
          productId: '0',
          productImage: VRJ,
          productName: 'Packable Beach Towel / Perla (Free Size)',
          variant: "Perla",
          size: "+",
          price: "$55",
          sku: "000013",
          quantity: 1,
        },
      ],
      totalPrice: "$55",
      status: "DELIVERED",
      trackingNumber: "SEBG1307156373607108608",
    },]
  },
]

export const mockTrackingStatus = [
  {
    status: "Order created",
    message: "",
    date: "01/10/2024 11:14:49",
  },
  {
    status: "Shipment picked up",
    message: "",
    date: "01/10/2024 11:14:49",
  },
  {
    status: "In transit to sorting facility",
    message: "",
    date: "01/10/2024 11:14:49",
  },
  {
    status: "Shipment arrived at international hub",
    message: "",
    date: "01/10/2024 11:14:49",
  },
  {
    status: "Arrived at local sorting facility",
    message: "",
    date: "01/10/2024 11:14:49",
  },
  {
    status: "Out for delivery",
    message: "Your package is on its way and is expected to arrive today, 15 January 2024",
    date: "01/10/2024 11:14:49",
  },
]

export const mockShippingAddress = [
  {
    id: 1,
    country: "United States",
    company: "Havoc",
    addressLine1: "123 Maple Street IL",
    addressLine2: "",
    zipCode: 6274,
    city: {code: "spf", name: "Springfield"},
    phoneNumber: "+1 (217) 555-1234",
    isDefault: true,
  },
  {
    id: 2,
    country: "United States",
    company: "Softrigger",
    addressLine1: "1234 Elm Street Apt 567",
    addressLine2: "",
    zipCode: 90001,
    city: {code: "la", name: "Los Angeles, CA"},
    phoneNumber: "+1 (217) 555-1234",
    isDefault: false,
  },
];

export const mockMyRewardsList = [
  // mock status: used, ready, redeemable
  {
    id: 0,
    image: mockReward1,
    name: `Free Riri Triangle Top / Zooted`,
    points: 1500,
    status: 'redeemable',
  },
  {
    id: 1,
    image: mockReward2,
    name: `Free Sticker Pack / Blackbough Beach Club coupon`,
    points: 1000,
    status: 'redeemable', 
  },
  {
    id: 2,
    image: mockReward3,
    name: `Free Sticker Pack / Valentine's Day coupon`,
    points: 500,
    status: 'redeemable', 
  },
  {
    id: 3,
    image: mockReward4,
    name: `Free Sticker Pack / Paradise Point coupon`,
    points: 250,
    status: 'redeemable', 
  },
  {
    id: 4,
    image: mockReward5,
    name: `Free Tote Bag / Coco Frio coupon`,
    points: 800,
    status: 'redeemable', 
  },
  {
    id: 5,
    image: mockReward2,
    name: `Free Sophia Ruched Cheeky Bottoms / Caribbean`,
    points: 3000,
    status: 'redeemable', 
  },
  {
    id: 6,
    image: mockReward5,
    name: `Free Tote Bag / Coco Frio coupon`,
    points: 2250,
    status: 'redeemable', 
  },
]

export const mockReferrals = [
  {
    title: 'Eliza Reyes',
    email: "e****@g***.com",
    dateCreated: "January 20, 2025",
    points: 5000,
  },
  {
    title: '',
    email: "e****@g***.com",
    dateCreated: "December 31, 2024",
    points: 2000,
  },
  {
    title: 'Jane Doe',
    email: '(j****@g***.com)',
    dateCreated: "November 2, 2024",
    points: 5000
  },
]

export const mockHistoryPoints = [
  {
    title: 'Wrote a review',
    dateCreated: "January 20, 2025",
    points: 5000
  },
  {
    title: 'Redeemed Points for Free Sticker Pack / Blackbough Beach Club coupon',
    dateCreated: "December 31, 2024",
    points: -200
  },
  {
    title: 'Placed an order',
    dateCreated: "November 2, 2024",
    points: 5000
  },
  {
    title: 'Birthday Gift Reward',
    dateCreated: "August 04, 2024",
    points: 5000
  },
  {
    title: 'Placed an order',
    dateCreated: "March 04, 2024",
    points: 5000
  },
  {
    title: 'Welcome to the Club',
    dateCreated: "November 2, 2024",
    points: 5000
  },
  {
    title: 'Placed an order',
    dateCreated: "November 2, 2024",
    points: 5000
  },
]

export const testMyRewardsData = {
	created_at: "2024-05-13T08:52:42.247Z",
	exchange_description: "500 Blackbough Bucks",
	exchange_type: "fixed",
	formatted_variable_points_step_reward_value: null,
	id: 811560,
	minimum_points_price: 500,
	points_price: 500,
	reward: {id: 2379758, value: 10, name: 'Free Sticker Pack / La Playa coupon', description: 'Applies to one-time purchases. Reward expires 1 ye…ward can only be used on Sticker Pack / La Playa.', image_url: 'https://platform.smile.io/assets/rewards/new-exper…5be4b6f42f25b17b0f8e9bfc532fc6cab4d74470b5e2b.png',},
	updated_at: "2024-05-13T08:52:42.247Z",
	variable_points_max: null,
	variable_points_min: null,
	variable_points_step: null,
	variable_points_step_reward_value: null,
}

export const mockCollectionListing = [
	{
		id: 0,
		image: colListing1,
		title: "Golden Hour",
		link: "golden-hour",
	},
	{
		id: 1,
		image: colListing2,
		title: "Après Season",
		link: "apres-season",
	},
	{
		id: 2,
		image: colListing3,
		title: "Summer Vacays",
		link: "summer-vacay",
	},
	{
		id: 3,
		image: colListing1,
		title: "Golden Hour",
		link: "golden-hour",
	},
	{
		id: 4,
		image: colListing2,
		title: "Après Season",
		link: "apres-season",
	},
	{
		id: 5,
		image: colListing3,
		title: "Summer Vacays",
		link: "summer-vacay",
	},
	{
		id: 6,
		image: colListing1,
		title: "Golden Hour",
		link: "golden-hour",
	},
	{
		id: 7,
		image: colListing2,
		title: "Après Season",
		link: "apres-season",
	},
	{
		id: 8,
		image: colListing3,
		title: "Summer Vacays",
		link: "summer-vacay",
	},
]